import throttle from './utils/throttle';
import getUrlParam from './utils/getUrlParam';
import getActivityType from './utils/getActivityType';
/*
 * @Author: Michael 
 * @Date: 2018-10-11 13:53:15 
 * @Last Modified by: Michael
 * @Last Modified time: 2018-12-20 09:43:09
 * 图片懒加载类·
 */

class LazyImage {
  sceneElement: Element;
  _throttleFn!: any;
  /**
   * @dom 触发scroll函数的dom
   * @selector 实现图片懒加载的img的类名
   */
  constructor() {
    this.sceneElement = window as any;
    this.init();
  }

  inViewShow(): void {
    // 控制砍价模板按钮
    if (getUrlParam('type') === 'share' && getActivityType() === 'bargainType') {
      const operateBtn = document.querySelector(".operate-btn-outer");
      const clientRect = (operateBtn as HTMLElement).getBoundingClientRect();
      if (clientRect.bottom < 20) {
        const operateBtnFix = document.querySelector('.operate-btn-outer-fixed');
        if (operateBtnFix && !(operateBtnFix as any).classList.contains('show')) {
          (operateBtnFix as HTMLElement).classList.add('show');
        }
        if (!(operateBtn as any).classList.contains('hidden')) {
          (operateBtn as HTMLElement).classList.add('hidden');
        }
      } else {
        const operateBtnFix = document.querySelector('.operate-btn-outer-fixed');
        if (operateBtnFix && (operateBtnFix as any).classList.contains('show')) {
          (operateBtnFix as HTMLElement).classList.remove('show');
        }
        if ((operateBtn as any).classList.contains('hidden')) {
          (operateBtn as HTMLElement).classList.remove('hidden');
        }
      }
    }
    const imageElements: Array<HTMLImageElement> = Array.prototype.slice.call(document.querySelectorAll('.lazy-image'));
    let len: number = imageElements.length;
    for (let i: number = 0; i < len; i++) {
      let imageElement: HTMLImageElement = imageElements[i];
      const rect: ClientRect = imageElement.getBoundingClientRect();
      if (rect.top < (document.documentElement as HTMLElement).clientHeight) {
        (imageElement as any).src = imageElement.dataset.src;
        imageElements.splice(i, 1);
        len--;
        i--;
        if (imageElements.length === 0 && getUrlParam('type') !== 'edit' && getUrlParam('type') !== 'reEdit') {
          // this.sceneElement.removeEventListener('scroll', this._throttleFn)
        }
      }
    }
  }



  init(): void {
    this._throttleFn = throttle(this.inViewShow);
    window.addEventListener('scroll', this._throttleFn);
  }
}

export default LazyImage;